import request from "../libs/request";

import { BuildingId } from "../types/building";

import { postEtcSatisfactionRequest } from "./etcServices";
import { Pageable } from "./talkServices";

const baseUrl = "center/incommodity/manager";

export const REPORT_STATUS = {
  REQUESTED: 12,
  PROCESSING: 14,
  SCHEDULED: 14,
  COMPLETED2: 15,
  COMPLETED: 16,
  CANCELED2: 17,
  CANCELED: 18,
};

export const getStringFromReportStatusCode = {
  [REPORT_STATUS.REQUESTED]: "REQUESTED",
  [REPORT_STATUS.PROCESSING]: "PROGRESSED",
  [REPORT_STATUS.COMPLETED]: "COMPLETED",
  [REPORT_STATUS.COMPLETED2]: "COMPLETED",
  [REPORT_STATUS.CANCELED]: "CANCELED",
  [REPORT_STATUS.CANCELED2]: "CANCELED",
};

export const getKoreanStringFromReportStatusCode = {
  [REPORT_STATUS.REQUESTED]: "접수",
  [REPORT_STATUS.PROCESSING]: "접수확인",
  [REPORT_STATUS.COMPLETED]: "처리완료",
  [REPORT_STATUS.COMPLETED2]: "처리완료",
  [REPORT_STATUS.CANCELED]: "취소",
  [REPORT_STATUS.CANCELED2]: "취소",
};

export const getStepFromReportStatusCode = {
  [REPORT_STATUS.REQUESTED]: 1,
  [REPORT_STATUS.PROCESSING]: 2,
  [REPORT_STATUS.COMPLETED]: 3,
  [REPORT_STATUS.COMPLETED2]: 3,
  [REPORT_STATUS.CANCELED]: 0,
  [REPORT_STATUS.CANCELED2]: 0,
};

export type GetManagerReportListRequest = Partial<BuildingId> & {
  createdAtStart?: string;
  createdAtEnd?: string;
  status?: string;
  isScheduled?: boolean;
  isReservation?: boolean;
  isWithIn24?: boolean;
  page?: number;
  pageSize?: number;
};

export type ManagerReportSummaryItem = {
  count: number;
  status: string;
};

export type ManagerReportItem = {
  centerIncommodityId: number;
  buildingName: string;
  floorName: string;
  location: string;
  companyName: string;
  name: string;
  createdAt: string;
  status: string;
  isScheduled: boolean;
  isReservation: boolean;
  categoryName: string;
  description: string | string | null;
  spaceName: string | string | null;
  serviceName?: string;
};

export type GetManagerReportListResponse = {
  pageable: Pageable;
  items: ManagerReportItem[];
  summary: ManagerReportSummaryItem[];
};

export const getManagerReportList = (params: GetManagerReportListRequest) =>
  request.get<GetManagerReportListResponse>(baseUrl, { params });

export type S3File = {
  fileId: number;
  filePath: string;
};

export type ZadaraFile = {
  fileId: number;
  filePath: string;
  fileZadaraPath: string;
  fileZadaraId: number;
};

export type ReportDetailItem = BuildingId & {
  centerIncommodityId: number;
  vocId: string | null;
  serviceId: string | null;
  categoryName: string;
  atgBuildingId: string;
  buildingName: string;
  buildingFloorId: string | null;
  atgBuildingFloorId: string;
  floorName: string | null;
  buildingSpaceId: string | null;
  location: string;
  description: string;
  status: string;
  statusName: string;
  deadLine: string | null;
  createdAt: string;
  createdBy: number;
  createdByName: string;
  completedAt: string | null;
  completedBy: number | null;
  completedByName: string | null;
  completedByThumbnail: string | null;
  feedback: string | null;
  resource: string | null;
  worker: string | null;
  satisfaction: number;
  satisfactionComment: string | null;
  satisfactionCreatedAt: string | null;
  satisfactionCreatedBy: number;
  satisfactionCreatedByName: string;
  satisfactionCreatedByThumbnail: string | null;
  satisfactionId: number;
  satisfactionReplyComment: string | null;
  satisfactionReplyCreatedAt: string | null;
  satisfactionReplyCreatedBy: number;
  satisfactionReplyCreatedByName: string | null;
  satisfactionReplyCreatedByThumbnail: string | null;
  satisfactionReplyId: number;
  userFile: S3File | null;
  s3PreFile: S3File[];
  zadaraPrePath: string[] | null;
  s3PostFile: S3File[];
  zadaraPostPath: string[] | null;

  receiptedAt: string | null;
  receiptedBy: number;
  receiptedByName: string | null;

  canceledAt: string | null;
  createdByCompany: string;
  createdByMobileNumber: string;
  upperCategoryName: string;
  isScheduled: boolean;
  channel?: string;
  channelName?: string;
  largeCategory?: string;
  middleCategory?: string;
  smallCategory?: string;
  pushTypeCode?: string;
  zadaraPostPathList: ZadaraFile[];
  zadaraPrePathList: ZadaraFile[];
  equipmentTypeCodeName: null;
  modifiedAt: string | null;
  modifiedBy: number;
  modifiedByName: string | null;
};

export type GetManagerReportDetailRequest = {
  centerIncommodityId: number;
};

export const getManagerReportDetail = (params: GetManagerReportDetailRequest) =>
  request.get<ReportDetailItem>(`${baseUrl}/${params.centerIncommodityId}`);

export const workingManagerReport = (params: GetManagerReportDetailRequest) =>
  request.patch(`${baseUrl}/${params.centerIncommodityId}/working`);

export type ScheduleManagerReportRequest = GetManagerReportDetailRequest & {
  feedback: string;
};

export const scheduleManagerReport = (params: ScheduleManagerReportRequest) =>
  request.patch(`${baseUrl}/${params.centerIncommodityId}/scheduled`, params);

export const completeManagerReport = (
  params: GetManagerReportDetailRequest,
  formData: FormData
) =>
  request.patch(`${baseUrl}/${params.centerIncommodityId}/complete`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const modifyManagerReport = (
  params: GetManagerReportDetailRequest,
  formData: FormData
) =>
  request.patch(`${baseUrl}/${params.centerIncommodityId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const postIncommoditySatisfactionReply = (
  centerIncommodityId: string,
  params: Pick<postEtcSatisfactionRequest, "comment">
) => request.post(`${baseUrl}/satisfaction/${centerIncommodityId}`, params);
